import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = { threadId: String }
    static targets = ["syncDone", "syncActive", "syncError"]

    pendingSaves = new Set()
    failedSaves = new Set()
    #releaseHeight = null

    disconnect() {
        this.#releaseHeight?.()
    }

    getCreateUrl() {
        if (this.threadIdValue) {
            return `/frame/thread/${this.threadIdValue}/notes`
        }
        return `/frame/inbox/notes`
    }

    reloadStream() {
        const streamFrame = this.element.querySelector("turbo-frame#notes-stream")
        if (!streamFrame) return
        this.#holdHeight(streamFrame)
        const base = this.threadIdValue
            ? `/frame/thread/${this.threadIdValue}/notes/stream`
            : `/frame/inbox/notes/stream`
        streamFrame.src = `${base}?t=${Date.now()}`
    }

    // Turbo empties the frame before it fills it, and a page that short has the
    // reader's scroll position clamped to its new bottom. A turbo-frame is an
    // inline box, so the height is held on the block around it.
    #holdHeight(streamFrame) {
        this.#releaseHeight?.()
        this.element.style.minHeight = `${this.element.getBoundingClientRect().height}px`
        const release = () => {
            this.element.style.minHeight = ""
            streamFrame.removeEventListener("turbo:frame-load", release)
            streamFrame.removeEventListener("turbo:fetch-request-error", release)
            this.#releaseHeight = null
        }
        this.#releaseHeight = release
        streamFrame.addEventListener("turbo:frame-load", release)
        streamFrame.addEventListener("turbo:fetch-request-error", release)
    }

    ensurePlaceholder(beforeElement) {
        const stream = this.element.querySelector("#notes-stream")
        if (!stream) return

        if (stream.querySelector('[data-note-card-state-value="placeholder"]')) return

        const template = this.element.querySelector("template")
        if (!template) return

        const placeholder = template.content.cloneNode(true)
        if (beforeElement && stream.contains(beforeElement)) {
            beforeElement.before(placeholder)
        } else {
            // Fallback: insert after the first child (date separator)
            const first = stream.children[0]
            if (first) {
                first.after(placeholder)
            } else {
                stream.prepend(placeholder)
            }
        }
    }

    syncStart(key) {
        this.failedSaves.delete(key)
        this.pendingSaves.add(key)
        this.#renderSyncState()
    }

    syncDone(key) {
        this.pendingSaves.delete(key)
        this.failedSaves.delete(key)
        this.#renderSyncState()
    }

    syncError(key) {
        this.pendingSaves.delete(key)
        this.failedSaves.add(key)
        this.#renderSyncState()
    }

    #renderSyncState() {
        if (!this.hasSyncDoneTarget || !this.hasSyncActiveTarget || !this.hasSyncErrorTarget) return

        this.syncDoneTarget.style.display = "none"
        this.syncActiveTarget.style.display = "none"
        this.syncErrorTarget.style.display = "none"

        if (this.pendingSaves.size > 0) {
            this.syncActiveTarget.style.display = ""
            return
        }

        if (this.failedSaves.size > 0) {
            this.syncErrorTarget.style.display = ""
            return
        }

        this.syncDoneTarget.style.display = ""
    }
}
